import { POS_PRODUCT } from "../../types/ProductType";

import axios from "axios";

const posProductAction = (data) => {
	return {
		type: POS_PRODUCT,
		payload: data,
	};
};

export const loadPosProduct = (id, page = 1, limit = 20) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const { data } = await axios.get(`product?query=search&prod=${id}&page=${page}&limit=${limit}`);

			// Handle both old and new response formats
			const responseData = data.data && data.pagination ? data.data : data;

			//dispatching data
			dispatch(posProductAction(responseData));

			return { status: "success", data: responseData };
		} catch (error) {
			console.log(error.message);
		}
	};
};
